// Helpers for remembering the freelancer's most recently used project
// so pickers can pre-select it next time.
const LAST_USED_KEY = "wfmd_last_project_id";

export function getLastProjectId() {
  try {
    return localStorage.getItem(LAST_USED_KEY) || null;
  } catch {
    return null;
  }
}

export function setLastProjectId(projectId) {
  try {
    if (projectId) {
      localStorage.setItem(LAST_USED_KEY, projectId);
    } else {
      localStorage.removeItem(LAST_USED_KEY);
    }
  } catch {
    // ignore quota / private mode failures
  }
}
